import React, { useState, useEffect } from 'react';
import ContentComponent from '../Component/ContentComponent';

interface IProps {
  channel: any;
  stage: any;
  module: any;
  submodule: any;
  allDataList: {
    channelList: any;
    stageList: any;
    moduleList: any;
    submoduleList: any;
  };
  setTabData: (val: any) => void;
  setAllDataList: (val: any) => void;
  selectedStatus?: string;
  selectedData?: any;
}

export default function ContentContainer(props: IProps) {
  const getDefaultTab = (submodule: any) => {
    if (submodule?.type === 'Exam' || submodule?.type === 'Quiz') return 'Question';
    return 'Slide';
  };

  const [currentTab, setCurrentTab] = useState(() => getDefaultTab(props.submodule));

  useEffect(() => {
    setCurrentTab(getDefaultTab(props.submodule));
    // eslint-disable-next-line
  }, [props.submodule?.id]);

  const handleOnTabClick = (params: string) => setCurrentTab(params);

  return (
    <ContentComponent
      currentTab={currentTab}
      handleChangeTab={handleOnTabClick}
      {...props}
    />
  );
}
